import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SoldToFilterService } from '../../../../../shared/services/sold-to-filter/sold-to-filter.service';

export interface ShipToListFilter {
  searchInput: string;
  soldTosDropdown: string[];
  showOnlyConnected: boolean;
  pageSizeDropdown: number;
}

export type ShipToListFilterFormControls = { [key in keyof ShipToListFilter]: AbstractControl };
export type ShipToListFilterFormGroup = UntypedFormGroup & { value: ShipToListFilter; controls: ShipToListFilterFormControls };
@Component({
  selector: 'py-user-details-ship-to-list-filter',
  templateUrl: './user-details-ship-to-list-filter.component.html',
  styleUrls: ['./user-details-ship-to-list-filter.component.scss'],
  standalone: false,
})
export class UserDetailsShipToListFilterComponent implements OnDestroy {
  @Input() filterForm: ShipToListFilterFormGroup;
  @Input() showConnectedToPermissionDropdown: boolean;

  @Output() searchInputEnterPress = new EventEmitter<void>();

  constructor(private soldToFilterService: SoldToFilterService) {}

  private subscriptions = new Subscription();

  private get searchInputFormControl(): UntypedFormControl {
    return this.filterForm.get('searchInput') as UntypedFormControl;
  }

  onResetSearchInput(): void {
    this.searchInputFormControl.reset();
  }

  ngOnDestroy(): void {
    this.soldToFilterService.resetSoldToFilterData();
    this.subscriptions.unsubscribe();
  }
}
